/** Spieler-Token je Lobby im Browser merken, damit ein Neuladen keinen neuen Beitritt erzwingt. */
const key = (code: string) => `noxbury:${code}`;

export interface StoredSession {
  playerId: string;
  token: string;
}

export function loadSession(code: string): StoredSession | null {
  try {
    const raw = localStorage.getItem(key(code));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredSession;
    return parsed.token && parsed.playerId ? parsed : null;
  } catch {
    return null;
  }
}

export function saveSession(code: string, session: StoredSession): void {
  try {
    localStorage.setItem(key(code), JSON.stringify(session));
  } catch {
    // Privates Fenster ohne Speicher: Die Sitzung gilt dann nur für diesen Tab.
  }
}

export function clearSession(code: string): void {
  try {
    localStorage.removeItem(key(code));
  } catch {
    /* ignorieren */
  }
}
